import { FunctionComponent, useState, useEffect, useRef, useMemo } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./CycleDetails.css";
import arrowLeftIcon from "../../assets/icons/arrow--left.svg";
import GroupComponent from "../../molecules/CgGroupComponent/GroupComponent";
import ConfirmationModal from "../../molecules/CgConfirmationModal/ConfirmationModal";
import { getDecryptedData, getEncryptedBody } from "../../utils/common";
import API from "../../services/rest/api";
import RequestToUpload from "../../molecules/CgRequestToUpload/RequestToUpload";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from "../../atoms/Dropdown";
import {
  DEFAULT_CARE_COINS,
  NIVOLUMAB,
  TUCATINIB,
} from "../../data/nivoConsts";
import Input from "../../atoms/Input/Input";
import { SIGRIMA, vivitraStatusOptions } from "../../data/sigrimaConst";
import Button from "../../atoms/Button/Button";
import UpcomingCycleDetailsV2 from "./UpcomingCycleDetailsV2";
import useScheduleVisitV2 from "./hooks/useScheduleVisitV2";
import useUpdateVisitV2 from "./hooks/useUpdateVisitV2";
import useInitialCycleDataV2 from "../../hooks/useInitialCycleDataV2";
import useTherapyDrugs from "../../hooks/useTherapyDrugs";
import { ORDER_STATUS } from "../../constants/common";
import moment from "moment";
import {
  OCR_RECORDS_POLL_INTERVAL_MS,
  recordsHaveOcrProcessing,
} from "../../utils/ocrRecordsPolling";

/**
 * OCR often returns `next_cycle_date` as `dd/mm/yyyy` (e.g. `07/04/2026` = 7 Apr 2026).
 * HTML `<input type="date">` needs `YYYY-MM-DD`. Moment parses `DD/MM/YYYY` explicitly (strict).
 */
function parseNextCycleDateForDateInput(raw: string | undefined): string | undefined {
  if (raw == null || typeof raw !== "string") {
    return undefined;
  }
  const s = raw.trim();
  if (!s) {
    return undefined;
  }

  const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "D/M/YYYY", "DD-MM-YYYY", "D-M-YYYY"];

  for (const fmt of formats) {
    const m = moment(s, fmt, true);
    if (m.isValid()) {
      return m.format("YYYY-MM-DD");
    }
  }

  const fallback = moment(s);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD") : undefined;
}

const CycleDetails: FunctionComponent = () => {
  interface VivitraDate {
    claimed_date?: string;
    ordered_date?: string;
    shipped_date?: string;
    delivered_date?: string;
  }
  const [userDetails, setUserDetails] = useState<any>(null);
  const [patientData, setPatientData] = useState<any>(null);
  const [coins, setCoins] = useState<any>();
  const [token, setToken] = useState<any>();
  const [isRewardsAssign, setIsRewardsAssign] = useState<boolean>(false);

  const [isRecordsFetching, setIsRecordsFetching] = useState<boolean>(false);
  const [isPrescriptionApproved, setIsPrescriptionApproved] =
    useState<boolean>(false);
  const [isDischargeApproved, setIsDischargeApproved] =
    useState<boolean>(false);
  const [isPurchaseApproved, setIsPurchaseApproved] = useState<boolean>(false);
  const [isPrescriptionrReupload, setIsPrescriptionReupload] =
    useState<boolean>(false);
  const [isDischargeReupload, setIsDischargeReupload] =
    useState<boolean>(false);
  const [isPurchaseReupload, setIsPurchaseReupload] = useState<boolean>(false);
  const [isVivitraEnabled, setIsVivitraEnabled] = useState<any>(null);
  const [isConfirmed, setIsConfirmed] = useState<any>(null);
  const [showPurchaseApprove, setShowPurchaseApprove] =
    useState<boolean>(false);
  const [showDischargeApprove, setShowDischargeApprove] =
    useState<boolean>(false);
  const [showPurchaseReupload, setShowPurchaseReupload] =
    useState<boolean>(false);
  const [showDischargeReupload, setShowDischargeReupload] =
    useState<boolean>(false);
  const [showPrescriptionReupload, setshowPrescriptionReupload] =
    useState<boolean>(false);
  const [selectedPdfType, setSelectedPdfType] = useState<string>("");
  const [showPrescriptionApprove, setShowPrescriptionApprove] =
    useState<boolean>(false);
  const [showCreateCycleModal, setShowCreateCycleModal] =
    useState<boolean>(false);
  // const [showReqUploadModal, setShowReqUploadModal] = useState<boolean>(false);
  const modalRef = useRef<HTMLDivElement>(null);

  const [dischargeSummaryPdfUrl, setDischargeSummaryPdfUrl] = useState<
    string | null
  >(null);
  const [purchaseInvoicePdfUrl, setPurchaseInvoicePdfUrl] = useState<
    string | null
  >(null);
  const [prescriptionPdfUrl, setPrescriptionPdfUrl] = useState<string | null>(
    null
  );
  const [dischargeSummaryId, setDischargeSummaryId] = useState<string | null>(
    null
  );
  const [purchaseInvoiceId, setPurchaseInvoiceId] = useState<string | null>(
    null
  );
  const [prescriptionId, setPrescriptionId] = useState<string | null>(null);
  /** Full API row for each document type — used by `GroupComponent` for reupload payload. */
  const [dischargeSummaryRecordData, setDischargeSummaryRecordData] =
    useState<any>(null);
  const [purchaseInvoiceRecordData, setPurchaseInvoiceRecordData] =
    useState<any>(null);
  const [prescriptionRecordData, setPrescriptionRecordData] =
    useState<any>(null);
  const [editedDetails, setEditedDetails] = useState<any>({});
  const [vivitraDetails, setVivitraDetails] = useState<any>({});
  const [orderDetails, setOrderDetails] = useState<any>({});
  // Not in Use as of now
  // const [visitData, setVisitData] = useState<any>({});
  // const [productName, setProductName] = useState<string>('');
  // const [productType, setProductType] = useState<string>('');
  const [vivitraStatus, setVivitraStatus] = useState<string>("");
  const [orderStatus, setOrderStatus] = useState<string>("");
  const [schedulingVisit, setSchedulingVisit] = useState<boolean>(false);
  const [ocrPollActive, setOcrPollActive] = useState(false);

  // const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  // const FetchPDFUrlAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/get_patient_record_onco_without_visit_id`;
  const VisitRecordsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/get_records`;
  const PatientDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/patient_details_by_id`;
  const UpdateVisitDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/update_patient_visit`;
  const ScheduleVisitDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/schedule_patient_visit`;
  const UpdateRecordStatusAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/update_patient_record_data`;

  const params = useParams();
  const navigate = useNavigate();
  const location: any = useLocation();

  const handleBackButtonClick = (screen: string) => {
    // navigate(-1);
    navigate(`/${screen}/:token`);
  };

  const handleButtonClick = (screen: string) => {
    navigate(`/${screen}`);
  };

  useEffect(() => {
    const token: any = params.token;
    getProfileDetails();
    fetchVisitRecords();

    localStorage.setItem(
      "token",
      location.state?.token === ":token" || location.state?.token === undefined
        ? token
        : location.state?.token
    );
    sessionStorage.setItem(
      "token",
      location.state?.token === ":token" || location.state?.token === undefined
        ? token
        : location.state?.token
    );
    setToken(localStorage.getItem("token"));
    // setUserDetails(localStorage.getItem("health-coach-id"))
  }, [params]);

  // Add the isNivo flag
  const isNivo = useMemo(() => {
    const drugType = location?.state?.support_program_drug;
    return drugType === NIVOLUMAB;
  }, [location?.state?.support_program_drug]);

  const isTucatinib = useMemo(() => {
    const drugType = location?.state?.support_program_drug;
    return drugType === TUCATINIB;
  }, [location?.state?.support_program_drug]);

  const isSigrima = useMemo(() => {
    const drugType = location?.state?.support_program_drug;
    return drugType === SIGRIMA;
  }, [location?.state?.support_program_drug]);

const cancerType = useMemo(() => {
  return location?.state?.visitMetaInfo?.cancer_type;
}, [location?.state?.visitMetaInfo?.cancer_type]);

  /** Patient cycles / patient summary navigate with `visitID`; some paths may use `visitId`. */
  const cycleDetailsVisitId = useMemo(() => {
    const raw = location?.state?.visitID ?? location?.state?.visitId;
    if (raw == null || raw === "") return undefined;
    return String(raw);
  }, [location?.state?.visitID, location?.state?.visitId]);

  // Initialize V2 hooks for upcoming cycle
  const { schedulingVisit: schedulingVisitV2, scheduleVisitDetailsV2 } =
    useScheduleVisitV2({
    location,
    patientData,
    userDetails,
    editedDetails,
    navigate,
  });

  const { updatingVisit: updatingVisitV2, updateVisitDetailsV2 } =
    useUpdateVisitV2({
    location,
    patientData,
    userDetails,
    editedDetails,
    isRewardsAssign,
    coins,
  });

  // V2: Call initial cycle data API on component mount for upcoming cycle
  const {
    loading: loadingUpcomingCycleData,
    data: upcomingCycleData,
    error: upcomingCycleError,
  } = useInitialCycleDataV2({
    patientId: location.state?.patientId,
    visitId: location.state?.visitID,
    cycleType: "upcoming",
    enabled: !!location.state?.patientId && !!location.state?.visitID,
  });

  // Fetch therapy drugs for validation logic
  const { 
    primaryDrugsFull, 
    getCancerTypesForPrimary 
  } = useTherapyDrugs();

  const buildRecordDataFromVisitItem = (item: any) => {
    const docData = item?.document_data;
    const docName =
      item?.document_name ??
      (Array.isArray(docData) ? docData[0] : docData) ??
      "";
    return {
      ...item,
      title: item?.title,
      document_name: docName,
      container_name: item?.container_name ?? "patient-reports",
      patient_id:
        item?.patient_id ??
        patientData?.patient_id ??
        location?.state?.patientId,
      patient_records_id: item?.patient_records_id,
      test_type_id: item?.test_type_id,
    };
  };

  const silentNextVisitRecordsFetchRef = useRef(false);
  const fetchVisitRecordsRef = useRef<() => Promise<void>>(async () => {});

  const fetchVisitRecords = async () => {
    const silent = silentNextVisitRecordsFetchRef.current;
    silentNextVisitRecordsFetchRef.current = false;
    if (!silent) {
      setIsRecordsFetching(true);
    }
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY || '';
      const body = {
        page: "1",
        record_meta_info: {
          visit_id: cycleDetailsVisitId ?? location?.state.visitID,
        },
        patient_id: location?.state.patientId,
      };

      const enCryptedBody = getEncryptedBody(body);

      const response = await fetch(VisitRecordsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch PDF URL");
      }
      const data = await response.json();
      const decryptedData = getDecryptedData(data);
      const visitRecordData = JSON.parse(decryptedData).data;
      // setVisitData(visitRecordData) // Not in use

      setIsPrescriptionApproved(false);
      setIsDischargeApproved(false);
      setIsPurchaseApproved(false);
      setIsPrescriptionReupload(false);
      setIsDischargeReupload(false);
      setIsPurchaseReupload(false);
      setDischargeSummaryPdfUrl(null);
      setPurchaseInvoicePdfUrl(null);
      setPrescriptionPdfUrl(null);
      setDischargeSummaryId(null);
      setPurchaseInvoiceId(null);
      setPrescriptionId(null);
      setDischargeSummaryRecordData(null);
      setPurchaseInvoiceRecordData(null);
      setPrescriptionRecordData(null);

      if (!silent) {
        setIsRecordsFetching(false);
      }

      visitRecordData?.forEach((item: any) => {
        const recordData = buildRecordDataFromVisitItem(item);
        setPdfUrlByTitle(
          item.title,
          item.document_url,
          item.patient_records_id,
          item?.record_meta_info?.report_status,
          recordData
        );
      });
      setOcrPollActive(recordsHaveOcrProcessing(visitRecordData));
    } catch (error) {
      if (!silent) {
        setIsRecordsFetching(false);
      }
      setOcrPollActive(false);
      console.error("Error fetching PDF URL:", error);
    }
  };

  fetchVisitRecordsRef.current = fetchVisitRecords;

  useEffect(() => {
    const patientId = location.state?.patientId;
    if (!ocrPollActive || !patientId) {
      return;
    }
    const id = window.setInterval(() => {
      silentNextVisitRecordsFetchRef.current = true;
      void fetchVisitRecordsRef.current();
    }, OCR_RECORDS_POLL_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [ocrPollActive, location.state?.patientId]);

  //funtion to get profile details
  const getProfileDetails = async () => {
    try {
      const userInfo = await API.GetProfileDetails();

      setUserDetails(userInfo?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  // Function to set state based on title
  const setPdfUrlByTitle = (
    title: any,
    url: any,
    recordId: any,
    reportStatus: any,
    recordData?: any
  ) => {
    switch (title) {
      case "Discharge Summary":
        setDischargeSummaryPdfUrl(url);
        setDischargeSummaryId(recordId);
        setDischargeSummaryRecordData(recordData ?? null);
        if (reportStatus === "Approved") {
          setIsDischargeApproved(true);
        } else if (reportStatus === "Rejected") {
          setIsDischargeReupload(true);
        }
        break;
      case "Purchase Invoice":
        setPurchaseInvoicePdfUrl(url);
        setPurchaseInvoiceId(recordId);
        setPurchaseInvoiceRecordData(recordData ?? null);
        if (reportStatus === "Approved") {
          setIsPurchaseApproved(true);
        } else if (reportStatus === "Rejected") {
          setIsPurchaseReupload(true);
        }
        break;
      case "Prescription":
      case "Prescriptions":
      case "Doctor Prescription":
        setPrescriptionPdfUrl(url);
        setPrescriptionId(recordId);
        setPrescriptionRecordData(recordData ?? null);
        if (reportStatus === "Approved") {
          setIsPrescriptionApproved(true);
        } else if (reportStatus === "Rejected") {
          setIsPrescriptionReupload(true);
        }
        break;
      default:
        // Handle other cases if needed
        break;
    }
  };

  useEffect(() => {
    fetchPatientDetails();
    fetchLatestCycleData(); // Fetch latest cycle data to populate fields
    setVivitraDetails(location?.state?.visitMetaInfo);
    
    // Initialize order details with correct date based on status
    const visitMetaInfo = location?.state?.visitMetaInfo;
    if (visitMetaInfo) {
      let statusDate = "";
      
      // Parse order_date JSON if it exists
      if (visitMetaInfo.order_date) {
        try {
          const orderDateObj = typeof visitMetaInfo.order_date === "string" 
            ? JSON.parse(visitMetaInfo.order_date) 
            : visitMetaInfo.order_date;
          
          // Determine which date to use based on order_status
          const status = visitMetaInfo.order_status || "";
          if (status.toLowerCase() === ORDER_STATUS.ORDERED && orderDateObj.ordered_date) {
            statusDate = orderDateObj.ordered_date;
          } else if (status.toLowerCase() === ORDER_STATUS.SHIPPED && orderDateObj.shipped_date) {
            statusDate = orderDateObj.shipped_date;
          } else if (status.toLowerCase() === ORDER_STATUS.DELIVERED && orderDateObj.delivered_date) {
            statusDate = orderDateObj.delivered_date;
          }
        } catch (error) {
          console.error("Error parsing order_date:", error);
        }
      }
      
      setOrderDetails({
        ...visitMetaInfo,
        status_date: statusDate || visitMetaInfo.status_date || "",
      });
    }
  }, []);

  // Fetch latest cycle data from get_patient_visit_details API
  const fetchLatestCycleData = async () => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      
      const body = {
        patient_id: location.state?.patientId,
        records_needed: 1, // Get only the most recent cycle
      };

      console.log("Fetching latest cycle data for upcoming cycle:", body);

      const encryptedBody = getEncryptedBody(body);

      const GetPatientVisitDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/get_patient_visit_details`;

      const response = await fetch(GetPatientVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${encryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch latest cycle data");
      }

      const responseData = await response.json();
      const decryptedData = getDecryptedData(responseData);
      const parsedData = typeof decryptedData === "string" 
        ? JSON.parse(decryptedData) 
        : decryptedData;

      console.log("Latest cycle data (decrypted):", parsedData);

      // Extract the most recent visit (first item in array)
      const latestVisit = parsedData?.data?.[0];
      
      if (latestVisit?.visit_meta_info) {
        const visitMetaInfo = latestVisit.visit_meta_info;
        const primaryDrugs = visitMetaInfo?.primary_drugs || [];
        const secondaryDrugs = visitMetaInfo?.secondary_drugs || [];
        
        // Extract primary drug info
        const primaryDrug = primaryDrugs[0];
        const primaryDrugName = primaryDrug?.drug_name || location.state?.support_program_drug || "";
        const primaryDrugFree = primaryDrug?.is_free || "0";
        
        // Map secondary drugs to our format
        const mappedSecondaryDrugs = secondaryDrugs.map((drug: any) => ({
          drug_name: drug.drug_name || "",
          is_free: parseInt(drug.is_free) || 0,
        }));
        
        // Check if the therapy has indications in the API
        // If not, set indication to empty string (don't carry over old value)
        let therapyIndication = "";
        const cancerTypeValue = visitMetaInfo?.cancer_type || "";
        const therapyTypeValue = visitMetaInfo?.therapy_type || "";
        
        if (primaryDrugName && cancerTypeValue && therapyTypeValue) {
          const cancerTypes = getCancerTypesForPrimary(primaryDrugName);
          const selectedCancerType = cancerTypes.find((ct: any) => ct.value === cancerTypeValue);
          
          if (selectedCancerType) {
            const selectedTherapy = selectedCancerType.therapies?.find(
              (therapy: any) => therapy.value === therapyTypeValue
            );
            
            if (selectedTherapy && selectedTherapy.indications && selectedTherapy.indications.length > 0) {
              // Therapy HAS indications, so use the value from previous cycle
              therapyIndication = visitMetaInfo?.therapy_indication || "";
              console.log("   ✓ Therapy has indications, using previous value:", therapyIndication);
            } else {
              // Therapy has NO indications, set to empty string
              therapyIndication = "";
              console.log("   ✓ Therapy has no indications, setting to empty string");
            }
          }
        }
        
        setEditedDetails({
          primary_drug: primaryDrugName,
          cancer_type: visitMetaInfo?.cancer_type || "",
          therapy_type: visitMetaInfo?.therapy_type || "",
          therapy_indication: visitMetaInfo?.therapy_indication || therapyIndication, // Use checked value instead of raw API value
          is_primary_drug_free: parseInt(primaryDrugFree) || 0,
          secondary_drugs: mappedSecondaryDrugs,
          next_cycle_date: "",
          is_drug_free: parseInt(primaryDrugFree) || 0,
          care_coins: DEFAULT_CARE_COINS,
          isRewardsAssign: false,
        });
        
      } else {
        console.warn("No visit data found in response");
      }
    } catch (error) {
      console.error("Error fetching latest cycle data:", error);
    }
  };

  const fetchPatientDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      const body = JSON.stringify({
        patient_id: location.state?.patientId,
      });
      const response = await fetch(PatientDetailsAPI, {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
            token: `${token}`,
            health_secret: secretKey,
          },
          body: body,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      const userData = data?.data;
      setPatientData(userData);
      setCoins(userData?.coins);
      setIsVivitraEnabled(userData?.patient_meta_info?.vivitra_eligible);
      // setDoctorData(userData?.patient_link_doctor_details[0])
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  const handleApprove = (pdfType: string) => {
    setSelectedPdfType(pdfType);
    window.parent.postMessage("scrollToTop", "*");
    if (pdfType === "purchase") {
      setShowPurchaseApprove(true);
    } else if (pdfType === "discharge") {
      setShowDischargeApprove(true);
    } else if (pdfType === "prescriptions") {
      setShowPrescriptionApprove(true);
    }
    // else {
    //   setIsPrescriptionApproved(true)
    // }
  };

  const handleReupload = (pdfType: string) => {
    setSelectedPdfType(pdfType);
    window.parent.postMessage("scrollToTop", "*");
    if (pdfType === "purchase") {
      setShowPurchaseReupload(true);
    } else if (pdfType === "discharge") {
      setShowDischargeReupload(true);
    } else if (pdfType === "prescriptions") {
      setshowPrescriptionReupload(true);
    }
  };

  const handleRewards = (action: boolean) => {
    setIsRewardsAssign(action);
  };

  const updateVisitDetails = async () => {
    setSchedulingVisit(true);
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      // console.log('editedDetails', editedDetails);
      const body = {
        patient_visit_id: location.state?.visitID,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        // "follow_up_date": editedDetails?.next_cycle_date,
        updated_by: userDetails.health_coach_id,
        visit_meta_info: {
          target_therapy_drug: editedDetails?.product_name,
          therapy_type: editedDetails?.product_type,
          rewards_assigned: isRewardsAssign ? 1 : 0,
          ...(location?.state?.support_program_drug === TUCATINIB && {
            is_drug_free: editedDetails?.is_drug_free,
          }),
        },
        visit_status: "VA",
        // Conditionally add "assign_reward" and related parameters
        ...(isRewardsAssign
          ? {
              assign_reward: 1,
              assign_reward_params: {
                amount: parseInt(`${coins}00`),
                transactionType: "DOCUMENT_UPLOAD",
                notes: {
                  type: "visit_status_approved",
                },
                patientId: location.state?.patientId,
              },
            }
          : { assign_reward: 0 }),
      };

      const enCryptedBody = getEncryptedBody(body);
      const decryptedBody = getDecryptedData(enCryptedBody);

      const response = await fetch(UpdateVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to schedule a patient visit");
      }
      const data = await response.json();
      const decryptedData = getDecryptedData(data);
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    } finally {
      setSchedulingVisit(false);
    }
  };

  const vivitraDateString = location?.state?.visitMetaInfo?.vivitra_date ?? "";
  let vivitraDateObj: VivitraDate = {};

  try {
    if (vivitraDateString) {
      vivitraDateObj = JSON.parse(vivitraDateString);
    } else {
      console.error("vivitra_date string is empty");
    }
  } catch (error) {
    console.error("Error parsing vivitra_date:", error);
  }

  const updateVisitVivitraDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      // const userInfo = localStorage.getItem("userInfo"); 
      const body = {
        patient_visit_id: location.state?.visitID,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        // "follow_up_date": editedDetails?.next_cycle_date,
        updated_by: userDetails.health_coach_id,
        visit_meta_info: {
          vivitra_address: vivitraDetails.vivitra_address,
          vivitra_approved: 1,
          vivitra_status: vivitraDetails.vivitra_status,
          vivitra_date: JSON.stringify({
            claimed_date: vivitraDateObj?.claimed_date,
            ordered_date: vivitraDateObj?.ordered_date
              ? vivitraDateObj?.ordered_date
              : vivitraDetails?.vivitra_status === "Ordered"
              ? vivitraDetails?.status_date
              : "",
            shipped_date: vivitraDateObj?.shipped_date
              ? vivitraDateObj?.shipped_date
              : vivitraDetails?.vivitra_status === "Shipped"
              ? vivitraDetails?.status_date
              : "",
            delivered_date: vivitraDateObj?.delivered_date
              ? vivitraDateObj?.delivered_date
              : vivitraDetails?.vivitra_status === "Delivered"
              ? vivitraDetails?.status_date
              : "",
          }),

          // NEW KEYS
          order_address: vivitraDetails.vivitra_address,
          order_status: vivitraDetails.vivitra_status,
          order_date: JSON.stringify({
            claimed_date: vivitraDateObj?.claimed_date,
            ordered_date: vivitraDateObj?.ordered_date
              ? vivitraDateObj?.ordered_date
              : vivitraDetails?.vivitra_status === "Ordered"
              ? vivitraDetails?.status_date
              : "",
            shipped_date: vivitraDateObj?.shipped_date
              ? vivitraDateObj?.shipped_date
              : vivitraDetails?.vivitra_status === "Shipped"
              ? vivitraDetails?.status_date
              : "",
            delivered_date: vivitraDateObj?.delivered_date
              ? vivitraDateObj?.delivered_date
              : vivitraDetails?.vivitra_status === "Delivered"
              ? vivitraDetails?.status_date
              : "",
          }),
        },
      };

      const enCryptedBody = getEncryptedBody(body);
      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(UpdateVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to schedule a patient visit");
      }
      const data = await response.json();
      const decryptedData = getDecryptedData(data);
      console.log(decryptedData, "vivitra details updated successfully.");
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };

  const updateVivitraAddressDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      // const userInfo = localStorage.getItem("userInfo"); 
      const body = {
        patient_visit_id: location.state?.visitID,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        // "follow_up_date": editedDetails?.next_cycle_date,
        updated_by: userDetails.health_coach_id,
        visit_meta_info: {
          vivitra_address: vivitraDetails.vivitra_address,
        },
      };

      const enCryptedBody = getEncryptedBody(body);
      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(UpdateVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to schedule a patient visit");
      }
      toast.success("Data saved successfully!", { position: "top-right" }); // toast message
      window.parent.postMessage("scrollToTop", "*");
      const data = await response.json();
      const decryptedData = getDecryptedData(data);

    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };

  const updateVivitraApproveDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      // const userInfo = localStorage.getItem("userInfo");   
      const body = {
        patient_visit_id: location.state?.visitID,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        // "follow_up_date": editedDetails?.next_cycle_date,
        updated_by: userDetails.health_coach_id,
        visit_meta_info: {
          vivitra_approved: 1,
        },
      };

      const enCryptedBody = getEncryptedBody(body);
      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(UpdateVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to schedule a patient visit");
      }
      const data = await response.json();
      const decryptedData = getDecryptedData(data);

    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };
// console.log("editedDetails", location.state, patientData, userDetails);
const navigateToPatientSummary = () => {
  const token = localStorage.getItem("token");
  navigate(`/${"patient-summary/:token"}`, {
    state: { patientId: location.state?.patientId, token: `${token}` },
  });
};
  const scheduleVisitDetails = async () => {
    setSchedulingVisit(true);
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;

      const body = {
        patient_id: location.state?.patientId,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        follow_up_date: editedDetails?.next_cycle_date,
        updated_by: userDetails.health_coach_id,
        support_program_drug: location.state?.support_program_drug,
        visit_meta_info: {
          target_therapy_drug:
            location.state?.visitMetaInfo?.target_therapy_drug,
          therapy_type: location.state?.visitMetaInfo?.therapy_type,
          therapy_indication: location.state?.visitMetaInfo?.therapy_indication,
          cancer_type: location.state?.visitMetaInfo?.cancer_type,
          dosage: editedDetails?.upcoming_dosage,
          notes: location.state?.visitMetaInfo?.notes,
          ...(location?.state?.support_program_drug !== TUCATINIB && {
            is_drug_free: editedDetails?.is_drug_free,
          }),
          ...(location?.state?.support_program_drug === TUCATINIB && {
            is_drug_free: editedDetails?.is_drug_free,
          }),
          visit_cycle: 1 + Number(location.state?.cycleNumber), // Incremented from the current visit
        },
      };

      const enCryptedBody = getEncryptedBody(body);

      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(ScheduleVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to schedule a patient visit");
      }
      const data = await response.json();
      const decryptedData = getDecryptedData(data);

      navigateToPatientSummary();
      // setDischargeSummaryPdfUrl(data.pdfUrl);
      // setPurchaseInvoicePdfUrl(data.pdfUrl);
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    } finally {
      setSchedulingVisit(false);
    }
  };

  const handleVivitraDetail = async () => {
    toast.success("Data saved successfully!", { position: "top-right" });
    await updateVisitVivitraDetails();
  };

  const updateRecordStatus = async (recordId: any) => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      const body = {
        patient_records_id: recordId,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        record_meta_info: {
          report_status: "Approved",
        },
      };

      const enCryptedBody = getEncryptedBody(body);
      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(UpdateRecordStatusAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch PDF URL");
      }
      const data = await response.json();

      const decryptedData = getDecryptedData(data);
      JSON.parse(decryptedData);
      await fetchVisitRecords();
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };

  const handleConfirmation = async (action: boolean) => {
    switch (selectedPdfType) {
      case "purchase":
        setIsPurchaseApproved(action);
        await updateRecordStatus(purchaseInvoiceId);
        // setShowPurchaseApprove(false);
        break;
      case "discharge":
        setIsDischargeApproved(action);
        await updateRecordStatus(dischargeSummaryId);
        // setShowDischargeApprove(false);
        break;
      case "prescriptions":
        setIsPrescriptionApproved(action);
        await updateRecordStatus(prescriptionId);
        await updateVivitraApproveDetails();
        // setShowDischargeApprove(false);
        break;
      default:
        // setShowPrescriptionApprove(action);
        // setShowPrescriptionApprove(false);
        break;
    }
    handleCloseModal();
  };

  const handleReuploadConfirmation = async (action: boolean, text?: string) => {
    if (action) {
      switch (selectedPdfType) {
        case "purchase":
          setIsPurchaseReupload(action);
          await updateReuploadStatus(
            purchaseInvoiceId,
            text,
            "Discharge Summary"
          );
          break;
        case "discharge":
          setIsDischargeReupload(action);
          await updateReuploadStatus(
            dischargeSummaryId,
            text,
            "Purchase Invoice"
          );
          break;
        case "prescriptions":
          setIsPrescriptionReupload(action);
          await updateReuploadStatus(prescriptionId, text, "Prescriptions");
          break;
        default:
          // setShowPrescriptionApprove(action);
          // setShowPrescriptionApprove(false);
          break;
      }
    }
    handleCloseModal();
  };

  const updateReuploadStatus = async (
    recordId: any,
    text: any,
    type: string
  ) => {
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      const body = {
        patient_records_id: recordId,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        type_of_record: type,
        record_meta_info: {
          report_status: "Rejected",
          rejected_reason: text,
        },
      };

      const enCryptedBody = getEncryptedBody(body);

      // const decryptedBody = getDecryptedData(enCryptedBody)

      const response = await fetch(UpdateRecordStatusAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch PDF URL");
      }
      const data = await response.json();

      getDecryptedData(data);
      await fetchVisitRecords();
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };

  const handleCloseModal = () => {
    setShowDischargeApprove(false);
    setShowPurchaseApprove(false);
    setShowPrescriptionApprove(false);
    setShowDischargeReupload(false);
    setShowPurchaseReupload(false);
    setshowPrescriptionReupload(false);
    setSelectedPdfType("");
  };

  const handleAddCycleButtonClick = async () => {
    window.parent.postMessage("scrollToTop", "*");
    const updateSuccess = await updateVisitDetailsV2(); // Use V2 function
    if (updateSuccess) {
      await scheduleVisitDetailsV2(); // Use V2 function
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setEditedDetails({ ...editedDetails, [e.target.name]: e.target.value });
  };

  const handleVivitraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDetails({ ...vivitraDetails, [e.target.name]: e.target.value });
    setVivitraDetails({ ...vivitraDetails, [e.target.name]: e.target.value });
  };

  // Not in use
  // const handleProductNameChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setEditedDetails({ ...editedDetails, [e.target.name]: e.target.value });
  // };

  // const handleProductTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setEditedDetails({ ...editedDetails, [e.target.name]: e.target.value });
  // };
  const handleVivitraStatusChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newStatus = e.target.value;
    setVivitraStatus(newStatus);
    setOrderStatus(newStatus);
    
    // Parse order_date and determine the correct date based on new status
    let statusDate = "";
    const visitMetaInfo = location?.state?.visitMetaInfo;
    
    if (visitMetaInfo?.order_date) {
      try {
        const orderDateObj = typeof visitMetaInfo.order_date === "string" 
          ? JSON.parse(visitMetaInfo.order_date) 
          : visitMetaInfo.order_date;
        
        // Determine which date to use based on the new status
        if (newStatus.toLowerCase() === ORDER_STATUS.ORDERED && orderDateObj.ordered_date) {
          statusDate = orderDateObj.ordered_date;
        } else if (newStatus.toLowerCase() === ORDER_STATUS.SHIPPED && orderDateObj.shipped_date) {
          statusDate = orderDateObj.shipped_date;
        } else if (newStatus.toLowerCase() === ORDER_STATUS.DELIVERED && orderDateObj.delivered_date) {
          statusDate = orderDateObj.delivered_date;
        }
      } catch (error) {
        console.error("Error parsing order_date in handleVivitraStatusChange:", error);
      }
    }
    
    // Update both details objects with the new status and corresponding date
    setVivitraDetails({ 
      ...vivitraDetails, 
      [e.target.name]: newStatus,
      status_date: statusDate || vivitraDetails?.status_date || "",
    });
    setOrderDetails({ 
      ...orderDetails, 
      [e.target.name]: newStatus,
      status_date: statusDate || orderDetails?.status_date || "",
    });
  };

  const shouldEnableSaveButton = () => {
    // Check if PDF URL is present and approved
    if (prescriptionPdfUrl) {
      // Check if all three fields have values
      return (
        vivitraDetails.vivitra_status &&
        vivitraDetails.vivitra_address &&
        vivitraDetails.status_date &&
        isPrescriptionApproved
      );
    } else {
      return (
        vivitraDetails.vivitra_status &&
        vivitraDetails.vivitra_address &&
        vivitraDetails.status_date
      );
    }
  };

  /**
   * Applies OCR "Apply" from discharge summary into `editedDetails` for {@link UpcomingCycleDetailsV2}:
   * `primary_drug`, `cancer_type`, `therapy_type`, `therapy_indication`, `is_primary_drug_free`,
   * `next_cycle_date`, `secondary_drugs` (from OCR `secondary_drug` string). If `primary_drug` changes,
   * secondary rows are cleared unless OCR also sends `secondary_drug` (same idea as V2 `handlePrimaryDrugChange`).
   */
  const handleApply = (data: Record<string, string>) => {
    setEditedDetails((prev: Record<string, any>) => {
      const incomingPrimary = data?.primary_drug?.trim?.()?.toLowerCase() ?? data?.primary_drug;
      const primaryChanged =
        Boolean(incomingPrimary) && incomingPrimary !== prev?.primary_drug;

      let secondary_drugs = prev?.secondary_drugs;
      if (primaryChanged) {
        secondary_drugs = data?.secondary_drug
          ? [{ drug_name: data.secondary_drug, is_free: 0 }]
          : [];
      } else if (data?.secondary_drug) {
        secondary_drugs = [{ drug_name: data.secondary_drug, is_free: 0 }];
      }

      let is_primary_drug_free = prev?.is_primary_drug_free;
      const rawPf = data?.is_primary_drug_free;
      if (rawPf !== undefined && rawPf !== "") {
        const n = parseInt(String(rawPf), 10);
        if (Number.isFinite(n)) {
          is_primary_drug_free = n;
        }
      }

      const parsedNextCycleDate = parseNextCycleDateForDateInput(data?.next_cycle_date);

      return {
        ...prev,
        primary_drug: incomingPrimary || prev?.primary_drug,
        cancer_type: data?.cancer_type || prev?.cancer_type,
        next_cycle_date: parsedNextCycleDate ?? prev?.next_cycle_date,
        therapy_type: data?.therapy_type || prev?.therapy_type,
        therapy_indication: data?.therapy_indication || prev?.therapy_indication,
        is_primary_drug_free,
        secondary_drugs,
        upcoming_dosage: data?.upcoming_dosage || prev?.upcoming_dosage,
        product_name: data?.product_name || prev?.product_name,
        product_type: data?.product_type || prev?.product_type,
      };
    });
  };

  console.log("editedDetails", editedDetails);

  const isDrugFree = location.state?.visitMetaInfo?.is_drug_free;
  const locationState = location.state;
  console.log("locationState", locationState);
  
  return (
    <>
      {showDischargeApprove && (
        <div
          className={`confirmation-modal ${
            showDischargeApprove ? "overlay visible" : ""
          }`}
        >
          <ConfirmationModal
            show={showDischargeApprove}
            onConfirmation={handleConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      {showPurchaseApprove && (
        <div
          className={`confirmation-modal ${
            showPurchaseApprove ? "overlay visible" : ""
          }`}
        >
          <ConfirmationModal
            show={showPurchaseApprove}
            onConfirmation={handleConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      {showPrescriptionApprove && (
        <div
          className={`confirmation-modal ${
            showPrescriptionApprove ? "overlay visible" : ""
          }`}
        >
          <ConfirmationModal
            show={showPrescriptionApprove}
            onConfirmation={handleConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      {showDischargeReupload && (
        <div
          className={`confirmation-modal ${
            showDischargeReupload ? "overlay visible" : ""
          }`}
        >
          <RequestToUpload
            show={showDischargeReupload}
            onConfirmation={handleReuploadConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      {showPurchaseReupload && (
        <div
          className={`confirmation-modal ${
            showPurchaseReupload ? "overlay visible" : ""
          }`}
        >
          <RequestToUpload
            show={showPurchaseReupload}
            onConfirmation={handleReuploadConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      {showPrescriptionReupload && (
        <div
          className={`confirmation-modal ${
            showPrescriptionReupload ? "overlay visible" : ""
          }`}
        >
          <RequestToUpload
            show={showPrescriptionReupload}
            onConfirmation={handleReuploadConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      <div className="desktop-3">
        <div className="desktop-3-child" />
        <header className="summary-header">
          <div>
            <Link
              to={`/${"patient-summary/:token"}`}
              style={{ textDecoration: "none" }}
              state={{
                patientId: location.state?.patientId,
                token: `${token}`,
              }}
            >
              <div className="rectangle-v-e-c-t-o-r">
                <div className="frame-f-r-a-m-e">
                  <button
                  /*   onClick={ () => handleBackButtonClick("all-patients")}>
                  onClick={handleBackButtonClick}> */
                  >
                    <img
                      className="arrow-left"
                      loading="lazy"
                      alt=""
                      src={arrowLeftIcon}
                    />
                  </button>
                </div>
                <h3 className="products-list1">Cycle Details</h3>
              </div>
            </Link>
          </div>
          <div className="sub-header">
            <div className="patient-info">
              <div className="patient-info-container">
                <label className="patientInfo-label">Patient Info</label>
                <div className="patient-info-details">
                  <div>Name: {patientData?.name}</div>
                  <div>Contact: {patientData?.contact_no}</div>
                </div>
                {isNivo && (
                  <div className="patient-info-details">
                    <div className="trimmed-text max-w-md" title={cancerType}>
                      Cancer Type: {cancerType.slice(0, 90)}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* COMMENTED OUT - VIVITRA PROGRAM SECTION */}
            {/* {(location.state?.vivitraEligible || isDrugFree) && (
              <div className="vivitra">
                <div className="vivitra-sub-title">
                  <span>
                    {isNivo ? "NIVOLUMAB" : "VIVITRA"} -{" "}
                    {isDrugFree
                      ? "Free"
                      : location?.state?.visitMetaInfo?.vivitra_status}
                  </span>
                  <Link
                    to={`/${"patient-summary/:token"}`}
                    style={{ textDecoration: "none" }}
                    state={{
                      patientId: location.state?.patientId,
                      token: `${token}`,
                      refresh: true,
                    }}
                  >
                    <button
                      className={
                        location?.state?.visitStatus === "VA" ||
                        !shouldEnableSaveButton()
                          ? "vivitra-btn-disabled"
                          : "vivitra-btn"
                      }
                      onClick={handleVivitraDetail}
                      disabled={
                        location?.state?.visitStatus === "VA" ||
                        !shouldEnableSaveButton()
                      }
                    >
                      Save
                    </button>
                  </Link>
                </div>
                <div className="vivitra-container mt-4">
                  <div className="vivitra-address">
                    <Input
                      type="text"
                      id="vivitra_address"
                      className="vivitra-placeHolder"
                      label="Address"
                      placeholder="Enter delivery address "
                      name="vivitra_address"
                      value={vivitraDetails?.vivitra_address}
                      onChange={handleVivitraChange}
                    />
                  </div>
                  <div className="vivitra-status">
                    <div className="vivitra-status-field">
                      <Dropdown
                        options={vivitraStatusOptions}
                        onChange={handleVivitraStatusChange}
                        value={vivitraStatus}
                        label="Select Status"
                        name="vivitra_status"
                        id="vivitra_status"
                      />
                    </div>
                  </div>
                  <div className="status-date">
                    <Input
                      placeholder="Enter Status Date"
                      label="Date"
                      className="vivitra-placeHolder"
                      type="date"
                      name="status_date"
                      id="status_date"
                      value={vivitraDetails?.status_date}
                      onChange={handleVivitraChange}
                      min={new Date().toISOString().split("T")[0]}
                    />
                  </div>
                </div>
              </div>
            )} */}

            {/* NEW: Display all free drugs */}
            {(() => {
              const freeDrugs: string[] = [];

              // Check primary drugs for free drugs
              const primaryDrugs =
                location?.state?.visitMetaInfo?.primary_drugs || [];
              primaryDrugs.forEach((drug: any) => {
                if (drug.is_free === "1" || drug.is_free === 1) {
                  // Capitalize first letter
                  const drugName =
                    drug.drug_name.charAt(0).toUpperCase() +
                    drug.drug_name.slice(1);
                  freeDrugs.push(drugName);
                }
              });

              // Check secondary drugs for free drugs
              const secondaryDrugs =
                location?.state?.visitMetaInfo?.secondary_drugs || [];
              secondaryDrugs.forEach((drug: any) => {
                if (drug.is_free === "1" || drug.is_free === 1) {
                  // Capitalize first letter
                  const drugName =
                    drug.drug_name.charAt(0).toUpperCase() +
                    drug.drug_name.slice(1);
                  freeDrugs.push(drugName);
                }
              });

              // Display if there are any free drugs
              if (freeDrugs.length > 0) {
                return (
                  <div className="free-drug-container">
                    <div className="free-drug-title">
                      Free Drugs: {freeDrugs.join(", ")}
                    </div>
                    <div className="free-drug-form-container">
                        <Input
                          type="text"
                          id="vivitra_address"
                          className="vivitra-placeHolder"
                          label="Address"
                          placeholder="Enter delivery address "
                          name="vivitra_address"
                          value={orderDetails?.order_address}
                          onChange={handleVivitraChange}
                        />
                          <Dropdown
                            options={vivitraStatusOptions}
                            onChange={handleVivitraStatusChange}
                            value={orderStatus || orderDetails?.order_status}
                            label="Select Status"
                            name="vivitra_status"
                            id="vivitra_status"
                          />
                        <Input
                          placeholder="Enter Status Date"
                          label="Date"
                          className="vivitra-placeHolder"
                          type="date"
                          name="status_date"
                          id="status_date"
                          value={orderDetails?.status_date}
                          onChange={handleVivitraChange}
                          min={new Date().toISOString().split("T")[0]}
                        />

                    <div className="free-drug-save-button-container">
                      <Button
                        onClick={handleVivitraDetail}
                        disabled={location?.state?.visitStatus === "VA" || !shouldEnableSaveButton()}
                      >
                        Save
                      </Button>
                    </div>
                    </div>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        </header>
        <main className="group-f-r-a-m-e">
          <div className="cycle-details-container">
            <div className="f-r-a-m-e">
              {/* V2 Component - Unified for all drug types */}
              <UpcomingCycleDetailsV2
                locationState={locationState}
                editedDetails={editedDetails}
                handleChange={handleChange}
                setEditedDetails={setEditedDetails}
              />

              {/* OLD VERSION - Drug-specific components (Replaced by V2 Component) */}
              {/* {isNivo ? (
                <NivoCycleDetails
                  locationState={locationState}
                  editedDetails={editedDetails}
                  handleChange={handleChange}
                />
              ) : isTucatinib ? (
                <TucaCycleDetails
                  locationState={locationState}
                  editedDetails={editedDetails}
                  handleChange={handleChange}
                />
              ) : (
                <SigrimaCycleDetails
                  locationState={locationState}
                  editedDetails={editedDetails}
                  handleChange={handleChange}
                />
              )} */}
              {/* END OLD VERSION */}
              
              {/* OLD VERSION - Care Coins Section (Replaced by V2 Component) */}
              {/* {location.state?.visitStatus !== "VA" ? (
                <div className="products-list-input-field-grou">
                  <div className="care-coins-container">
                    <div className="input-field-container">
                      <label className="care-coin-label" htmlFor="productType">
                        Add {DEFAULT_CARE_COINS} care coins to patient wallet{" "}
                      </label>
                    </div>
                    <div className="btns-container">
                      <button
                        disabled={locationState?.visitStatus === "VA"}
                        className={
                          isRewardsAssign ? "modal-btns-active" : "modal-btns"
                        }
                        onClick={() => handleRewards(true)}
                      >
                        Yes
                      </button>
                      <button
                        disabled={locationState?.visitStatus === "VA"}
                        className={
                          isRewardsAssign ? "modal-btns" : "modal-btns-active"
                        }
                        onClick={() => handleRewards(false)}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              ) : null} */}
              {/* END OLD VERSION - Care coins field is now included in UpcomingCycleDetailsV2 component */}
            </div>
          </div>
          <div className="input-field-with-label-and-pla">
            {isVivitraEnabled && prescriptionPdfUrl && (
              <GroupComponent
                fRAMEFRAMEPlaceholder="Doctor Prescription"
                pdfUrl={prescriptionPdfUrl || ""}
                recordData={prescriptionRecordData}
                onApprove={() => handleApprove("prescriptions")}
                isApproved={isPrescriptionApproved}
                onReupload={() => handleReupload("prescriptions")}
                isReupload={isPrescriptionrReupload}
                patientId={patientData?.patient_id}
                visitId={cycleDetailsVisitId}
                onUploadSuccess={fetchVisitRecords}
                loading={isRecordsFetching}
              />
            )}
            <GroupComponent
              fRAMEFRAMEPlaceholder="Discharge Summary"
              pdfUrl={dischargeSummaryPdfUrl || ""}
              recordData={dischargeSummaryRecordData}
              onApprove={() => handleApprove("discharge")}
              isApproved={isDischargeApproved}
              onReupload={() => handleReupload("discharge")}
              isReupload={isDischargeReupload}
              patientId={patientData?.patient_id}
              visitId={cycleDetailsVisitId}
              onUploadSuccess={fetchVisitRecords}
              loading={isRecordsFetching}
              enableInsightsApply={true}
              handleApply={handleApply}
            />
            <GroupComponent
              fRAMEFRAMEPlaceholder="Purchase Invoice"
              pdfUrl={purchaseInvoicePdfUrl || ""}
              recordData={purchaseInvoiceRecordData}
              onApprove={() => handleApprove("purchase")}
              isApproved={isPurchaseApproved}
              onReupload={() => handleReupload("purchase")}
              isReupload={isPurchaseReupload}
              patientId={patientData?.patient_id}
              visitId={cycleDetailsVisitId}
              onUploadSuccess={fetchVisitRecords}
              loading={isRecordsFetching}
            />
            {/* Submit or Create upcoming cycle button */}
            <div
              className="frame-f-r-a-m-e1"
              style={{
                display:
                  location?.state?.visitStatus !== "VA" ? "block" : "none",
              }}
            >
              <Button
                className="w-full"
                onClick={handleAddCycleButtonClick}
                loading={schedulingVisitV2}
                disabled={(() => {

                  
                  // Check if purchase invoice is required
                  const purchaseInvoiceCheck = 
                    (location?.state?.visitMetaInfo?.is_purchase_invoice_required === "1" ||
                     location?.state?.visitMetaInfo?.is_purchase_invoice_required === 1)
                      ? !isPurchaseApproved
                      : false;
                  

                  
                  // Basic required fields
                  const basicFieldsCheck = 
                  !isDischargeApproved ||
                  !editedDetails?.next_cycle_date ||
                    !editedDetails?.primary_drug ||
                    !editedDetails?.cancer_type ||
                    !editedDetails?.therapy_type;
                  
                  
                  
                  // Detailed breakdown of what's missing
                  if (basicFieldsCheck) {
                    const missing = [];
                    if (!isDischargeApproved) missing.push("Discharge approval");
                    if (!editedDetails?.next_cycle_date) missing.push("Date");
                    if (!editedDetails?.primary_drug) missing.push("Primary drug");
                    if (!editedDetails?.cancer_type) missing.push("Cancer type");
                    if (!editedDetails?.therapy_type) missing.push("Therapy");
                    console.error("Missing fields:", missing.join(", "));
                  }
                  
                  // Indication check - only required if the CURRENTLY SELECTED therapy has indications
                  const indicationCheck = (() => {
                    // Get the currently selected therapy's indication options from API
                    const currentPrimaryDrug = editedDetails?.primary_drug;
                    const currentCancerType = editedDetails?.cancer_type;
                    const currentTherapyType = editedDetails?.therapy_type;
                    
                    
                    
                    if (!currentPrimaryDrug || !currentCancerType || !currentTherapyType) {
                      console.info("Indication check: Skipping (missing primary drug/cancer/therapy)");
                      return false; // Skip if any field is missing
                    }
                    
                    // Get cancer types for the selected primary drug
                    const cancerTypes = getCancerTypesForPrimary(currentPrimaryDrug);
                    console.info("Found cancer types from API:", cancerTypes.length);
                    
                    // If API data not loaded yet, skip validation (don't block button)
                    if (cancerTypes.length === 0) {
                      console.warn("WARNING: API data not loaded yet, skipping indication check");
                      return false; // Don't block if API not ready
                    }
                    
                    // Find the selected cancer type
                    const selectedCancerType = cancerTypes.find(
                      (ct: any) => ct.value === currentCancerType
                    );
                    
                    if (!selectedCancerType) {
                      console.info("Indication check: Skipping (cancer type not found in API)");
                      return false; // Cancer type not found, skip check
                    }
                    
                    // Find the selected therapy
                    const selectedTherapy = selectedCancerType.therapies?.find(
                      (therapy: any) => therapy.value === currentTherapyType
                    );
                    
                    if (!selectedTherapy) {
                      console.info("Indication check: Skipping (therapy not found in API)");
                      return false; // Therapy not found, skip check
                    }
                    
                    // Check if the therapy has indications
                    const hasIndications = selectedTherapy.indications && selectedTherapy.indications.length > 0;
                    
                    console.info("Therapy details:", {
                      therapy: selectedTherapy.value,
                      hasIndications,
                      indicationsCount: selectedTherapy.indications?.length || 0
                    });
                    
                    if (!hasIndications) {
                      console.info("Indication check: Therapy has no indications, skipping");
                      return false; // No indications available, indication is optional
                    }
                    
                    // Therapy has indications, so indication is required
                    const indicationMissing = !editedDetails?.therapy_indication || editedDetails?.therapy_indication === "";
                    
                    if (indicationMissing) {
                      console.error("Indication check: Therapy has indications but none selected");
                    } else {
                      console.info("Indication check: Indication selected:", editedDetails?.therapy_indication);
                    }
                    
                    return indicationMissing;
                  })();
                  
                  const isDisabled = purchaseInvoiceCheck || basicFieldsCheck || indicationCheck || schedulingVisitV2;
                  
                  
                  
                  return isDisabled;
                })()}
              >
                Create Upcoming Cycle
              </Button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CycleDetails;
